import { TICKET_THREAT_RESOLUTION_ID } from '@/pages/Ticket/Ticket.constants';

export enum TicketThreatOutcome {
  Remediate = 'remediate',
  Close = 'close'
}

export const MIN_MESSAGE_LENGTH = 10;

const THREAT_MITIGATED_RESOLUTION_ID = String(
  TICKET_THREAT_RESOLUTION_ID.THREAT_MITIGATED
);
const FALSE_POSITIVE_RESOLUTION_ID = String(
  TICKET_THREAT_RESOLUTION_ID.FALSE_POSITIVE
);

// Resolutions where the analyst's fix may or may not be complete, so the user
// must decide whether to keep monitoring (Remediate) or close outright.
// Every other resolution always results in the ticket being closed.
export const REMEDIATION_ELIGIBLE_RESOLUTION_IDS = [
  THREAT_MITIGATED_RESOLUTION_ID,
  FALSE_POSITIVE_RESOLUTION_ID
];

// resolutions only relevant to internal SOC workflows, hidden from customers
export const INTERNAL_ONLY_RESOLUTION_IDS = [
  TICKET_THREAT_RESOLUTION_ID.NO_RESPONSE,
  TICKET_THREAT_RESOLUTION_ID.ESCALATED_TO_DFIR
];

export const OUTCOME_OPTIONS: { value: TicketThreatOutcome; label: string }[] =
  [
    { value: TicketThreatOutcome.Remediate, label: 'Remediate' },
    { value: TicketThreatOutcome.Close, label: 'Close' }
  ];

export const DEFAULT_OUTCOME_BY_RESOLUTION: Record<
  string,
  TicketThreatOutcome
> = {
  [THREAT_MITIGATED_RESOLUTION_ID]: TicketThreatOutcome.Close,
  [FALSE_POSITIVE_RESOLUTION_ID]: TicketThreatOutcome.Remediate
};

export const SOC_CLOSE_HELP_TEXT =
  'Closes the ticket — SOC will no longer monitor it; your feedback helps the Quality Assurance team improve detections and processes.';

export const OUTCOME_HELP_TEXT: Record<
  string,
  Record<TicketThreatOutcome, string>
> = {
  [THREAT_MITIGATED_RESOLUTION_ID]: {
    [TicketThreatOutcome.Remediate]:
      'Keep the ticket open if you need to continue communicating with the SOC in this ticket with regard to any follow-up actions.',
    [TicketThreatOutcome.Close]: SOC_CLOSE_HELP_TEXT
  },
  [FALSE_POSITIVE_RESOLUTION_ID]: {
    [TicketThreatOutcome.Remediate]:
      'Keep the ticket open and make adjustments based on your feedback to reduce future noise.',
    [TicketThreatOutcome.Close]: SOC_CLOSE_HELP_TEXT
  }
};
